import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7cae25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "homeContainer",
  ref: "home"
}
const _hoisted_2 = {
  class: "section",
  style: {"background-color":"#FE9D35"},
  id: "about"
}
const _hoisted_3 = {
  class: "section",
  style: {"overflow":"show"}
}
const _hoisted_4 = {
  class: "section",
  style: {"padding-top":"0","padding-bottom":"0"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "section",
  style: {"background-color":"#161616","padding-top":"0","padding-bottom":"90px"}
}
const _hoisted_7 = {
  class: "section",
  style: {"background-color":"#0c0c0c"}
}
const _hoisted_8 = {
  class: "section",
  style: {"padding-top":"0","padding-bottom":"0"}
}
const _hoisted_9 = {
  class: "section",
  id: "contact"
}
const _hoisted_10 = { class: "floating" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#top",
  class: "touch"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Coverphoto = _resolveComponent("Coverphoto")!
  const _component_WhoWeAre = _resolveComponent("WhoWeAre")!
  const _component_MediaDisplay = _resolveComponent("MediaDisplay")!
  const _component_LightingDemo = _resolveComponent("LightingDemo")!
  const _component_GuiDisplay = _resolveComponent("GuiDisplay")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Legal = _resolveComponent("Legal")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Coverphoto, {
      class: "testIguess",
      id: "top"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_WhoWeAre, { class: "capped" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_MediaDisplay, { class: "capped" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "img",
        src: require('@/assets/split.png')
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_LightingDemo, { class: "capped" })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_GuiDisplay, { class: "capped" })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Contact)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Legal, { class: "capped" })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_FontAwesomeIcon, {
        class: "icon",
        color: "#fff",
        icon: "fa-solid fa-chevron-up"
      }),
      _hoisted_11
    ])
  ], 512))
}